/**
 * MifeLife v2 — Minimal blog index + post (placeholders for SEO).
 */
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import V2Nav from '../../components/v2/V2Nav';
import V2Footer from '../../components/v2/V2Footer';

const POSTS = [
  { slug: 'ai-ve-mentorluk',     title: 'AI ve Mentörlük: Geleceğin Eğitim Modeli', read: '6 dk',
    excerpt: 'AI yol haritası çizebilir — ama bir insanın eşlik etmesi şart. Hibrit modelin neden çalıştığı.',
    body: 'AI iki kritik şey yapar: ölçer ve önerir. Bir mentör üç kritik şey yapar: bağlama oturtur, hesap sorar, kapı açar. MifeLife bu ikisini birleştirir.' },
  { slug: 'kariyer-degisikligi', title: 'Kariyer Değişikliği Yaparken Mentör Neden Şart?', read: '5 dk',
    excerpt: 'Yön değişikliği kararından çok, yön değişikliği uygulamasında insan rehberliği gerekir.',
    body: 'Bir kararı vermek 1 saat sürer. Bir kararı doğru uygulamak 90 gün. İkisi farklı oyunlar.' },
  { slug: 'almanya-girisimcilik', title: 'Almanya\'da İş Kurmak: Türk Girişimciler İçin Rehber', read: '8 dk',
    excerpt: 'Steuerberater, GmbH, Handelsregister: Almanya\'da iş kurmadan önce bilmen gereken üç eşik.',
    body: 'Türk girişimciler için en zorlayıcı üç eşik finansal değil — bürokratik, dilsel ve kültüreldir.' },
];

export function V2BlogIndexPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0F0F1A] via-[#11111E] to-[#1A1A2E] text-white" data-testid="v2-blog-index">
      <V2Nav lang="tr" />
      <section className="pt-32 pb-12">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <div className="text-[11px] uppercase tracking-[0.18em] text-violet-300 mb-3">Blog</div>
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">AI, mentörlük ve yön bulma üzerine.</h1>
        </div>
      </section>
      <section className="pb-16">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-3">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="block rounded-2xl border border-white/10 bg-white/[0.02] p-6 hover:bg-white/[0.04] transition" data-testid={`v2-blog-card-${p.slug}`}>
              <div className="text-xs text-slate-500 mb-2">{p.read}</div>
              <h2 className="text-xl font-semibold tracking-tight mb-2">{p.title}</h2>
              <p className="text-sm text-slate-400">{p.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
      <V2Footer lang="tr" />
    </div>
  );
}

export function V2BlogPostPage() {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);
  if (!post) {
    return (
      <div className="min-h-screen bg-[#0F0F1A] text-white"><V2Nav /><div className="pt-40 text-center text-slate-400">Yazı bulunamadı.</div></div>
    );
  }
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0F0F1A] via-[#11111E] to-[#1A1A2E] text-white" data-testid="v2-blog-post">
      <V2Nav lang="tr" />
      <article className="pt-32 pb-20 max-w-3xl mx-auto px-5 sm:px-8">
        <Link to="/blog" className="text-xs text-violet-300 mb-6 inline-block">← Blog</Link>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight mb-3">{post.title}</h1>
        <div className="text-xs text-slate-500 mb-8">{post.read}</div>
        <p className="text-base text-slate-200 leading-relaxed">{post.body}</p>
        <div className="mt-12 p-6 rounded-2xl border border-violet-400/30 bg-violet-500/[0.05]">
          <div className="text-[11px] uppercase tracking-[0.18em] text-violet-300 mb-2">Devamı için</div>
          <Link to="/analiz" className="text-base font-semibold hover:underline">10 dakikalık AI Analizi yap →</Link>
        </div>
      </article>
      <V2Footer lang="tr" />
    </div>
  );
}
